var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          "show-add": _vm.showAdd,
          clearable: _vm.clearable,
          disabled: _vm.disabled,
          dense: _vm.dense,
          "auto-complete": _vm.autoComplete,
          "item-key": _vm.itemKey,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          onShowForm: function ($event) {
            _vm.showForm = true
          },
        },
      }),
      _c("sys-register-group-identifier", {
        attrs: { model: {}, show: _vm.showForm },
        on: {
          onCompleted: _vm.newItem,
          "update:show": function ($event) {
            _vm.showForm = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }